import React, { useState, useEffect } from "react";
import BASE_URL from "../../configs/api";
import { IoClose } from "react-icons/io5";
import { FaPlay } from "react-icons/fa";
import axios from "axios";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { GrFormNext } from "react-icons/gr";

const formatTime = (seconds) => {
  if (isNaN(seconds) || seconds === 0) return "0m";
  return `${Math.floor(seconds / 60)}m`;
};

const ContinueWatching = ({ title, movies }) => {
  const navigate = useNavigate();
  const [movieList, setMovieList] = useState([]);

  useEffect(() => {
    setMovieList(movies || []);
  }, [movies]);

  const handleSelectMovie = (movie) => {
    sessionStorage.setItem(
      `selectedEpisode-${movie.slug}`,
      JSON.stringify(movie)
    );
    navigate(
      `/xem-phim/${movie.phim.slug}/tap/${movie.phim.so_tap}?id=${movie.video_nguon}&ngonngu=${movie.phim.ngon_ngu}`
    );
  };

  const handleRemoveMovie = async (movieToRemove) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        toast.error("Không có token đăng nhập");
        return;
      }

      await axios.post(
        `${BASE_URL}/api/video-progress/delete_progress/`,
        { video_nguon_id: movieToRemove.video_nguon },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success("Đã xóa khỏi danh sách xem tiếp");
      setMovieList((prev) =>
        prev.filter((m) => m.video_nguon !== movieToRemove.video_nguon)
      );
    } catch (error) {
      toast.error("Lỗi khi xóa phim khỏi danh sách");
    }
  };

  if (!movieList || movieList.length === 0) return null;

  return (
    <section
      className="mb-2 md:mb-16"
      aria-labelledby="continue-watching-heading"
    >
      <header className="flex items-center justify-between mb-6 md:mb-8 px-1">
        <div className="flex items-center gap-4">
          <h2
            id="continue-watching-heading"
            className="text-2xl md:text-3xl lg:text-4xl font-bold text-white font-seogoe relative"
          >
            {title}
            <span className="sr-only">Danh sách phim đang xem tiếp</span>
            <div className="absolute -bottom-2 left-0 w-full h-1"></div>
          </h2>
          <div className="w-6 h-6 lg:w-9 lg:h-9 flex items-center justify-center bg-transparent border-2 border-orange-300 rounded-lg">
            <Link to="/user/continue-watching" title="Xem tất cả phim đang xem">
              <GrFormNext className="h-4 w-4 lg:h-6 lg:w-6 text-orange-400 hover:text-orange-300 transition-colors" />
            </Link>
          </div>
        </div>
      </header>

      <div
        className="overflow-x-auto whitespace-nowrap md:grid md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-6 gap-x-4 md:gap-y-6 grid-cols-2 sm:grid-cols-3 hide-scrollbar"
        role="list"
        aria-label="Danh sách các phim đang xem dở"
      >
        {movieList.map((movie) => {
          const progress =
            movie.duration > 0
              ? Math.min((movie.progress / movie.duration) * 100, 100)
              : 0;

          return (
            <article
              key={movie.phim_id || movie.video_nguon}
              className=" group relative bg-transparent rounded-lg inline-block w-[49%] mr-2 md:w-auto flex-shrink-0 md:mr-0"
              role="listitem"
              itemScope
              itemType="https://schema.org/TVEpisode"
            >
              <div
                className="relative aspect-[2.1/3] cursor-pointer overflow-hidden"
                role="button"
                tabIndex={0}
                onClick={() => handleSelectMovie(movie)}
                onKeyDown={(e) =>
                  ["Enter", " "].includes(e.key) && handleSelectMovie(movie)
                }
                aria-label={`Tiếp tục xem phim ${movie.phim.ten_phim} tập ${movie.phim.so_tap}`}
              >
                <img
                  src={movie.phim.poster_url}
                  alt={`Poster phim ${movie.phim.ten_phim}`}
                  className="w-full h-full object-cover rounded-lg"
                  loading="lazy"
                  decoding="async"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src =
                      "https://placehold.co/300x450/2d3748/e2e8f0?text=Error";
                  }}
                  itemProp="image"
                />

                {/* Play overlay */}
                <div className="absolute inset-0 flex items-center justify-center bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="bg-orange-500 rounded-full p-3 shadow-lg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-white"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M21.409 9.353a2.998 2.998 0 0 1 0 5.294L8.597 21.614C6.534 22.737 4 21.277 4 18.968V5.033c0-2.31 2.534-3.769 4.597-2.648z" />
                    </svg>
                  </div>
                </div>

                {/* Progress bar */}

                {/* Remove button */}
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemoveMovie(movie);
                  }}
                  className="absolute top-2 right-2 bg-slate-800/80 hover:bg-red-600 text-white/80 hover:text-white rounded h-7 w-7 md:h-8 md:w-8 flex items-center justify-center transition-all opacity-0 group-hover:opacity-100"
                  aria-label={`Xóa phim ${movie.phim.ten_phim} khỏi danh sách xem tiếp`}
                  title={`Xóa ${movie.phim.ten_phim}`}
                >
                  <IoClose className="h-4 w-4 md:h-5 md:w-5" />
                </button>
              </div>

              <div
                className="p-2 md:p-4"
                itemProp="partOfSeries"
                itemScope
                itemType="https://schema.org/TVSeries"
              >
                <h3
                  className="truncate text-center text-white text-xs md:text-base font-semibold cursor-pointer hover:text-orange-400 mb-1"
                  onClick={() => handleSelectMovie(movie)}
                  tabIndex={0}
                  role="button"
                  onKeyDown={(e) =>
                    ["Enter", " "].includes(e.key) && handleSelectMovie(movie)
                  }
                  itemProp="name"
                  title={movie.phim.ten_phim}
                >
                  {movie.phim.ten_phim}
                </h3>
                {movie.duration > 0 && (
                  <div
                    className=" w-full h-1 mt-4 mb-4 bg-white/20"
                    aria-hidden="true"
                  >
                    <div
                      className=" h-full bg-orange-500 transition-all"
                      style={{ width: `${progress}%` }}
                    />
                  </div>
                )}
                {movie.phim.ten_khac && (
                  <p
                    className="text-center leading-3 text-gray-400 text-[11px] lg:text-[12px] truncate"
                    title={movie.phim.ten_khac}
                  >
                    {movie.phim.ten_khac}
                  </p>
                )}

                <div className="text-[12px] leading-2 text-gray-300 text-center">
                  <span itemProp="episodeNumber">
                    Tập {movie.phim.so_tap || "?"}
                  </span>
                  <span className="mx-1 text-gray-400">&bull;</span>
                  <span className="text-orange-400 font-medium">
                    {formatTime(movie.progress)}
                  </span>
                  <span className="text-gray-300">
                    {" "}
                    / {formatTime(movie.duration)}
                  </span>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default ContinueWatching;
